module.exports = __webpack_public_path__ + "static/media/user3.bec872e6.jpeg";